import { useCallback, useState, MouseEvent } from "react";

import { Spinner, SpinnerColor, SpinnerSize } from "components/loaders";

import {
  StyledBasicButton,
  StyledBasicButtonContent,
  StyledBasicButtonLoader,
} from "./styles";
import { IBasicButtonProps } from "./types";

const BasicButton: React.FC<IBasicButtonProps> = ({
  children,
  disabled,
  onClick,
  uppercase,
  round,
  preserveLoadingWidth,
  ...props
}: IBasicButtonProps) => {
  const [loading, setLoading] = useState(false);

  const clickHandler = useCallback(
    async (e: MouseEvent<HTMLButtonElement>) => {
      if (onClick) {
        try {
          setLoading(true);
          await onClick(e);
        } catch (error) {
          throw error;
        } finally {
          setLoading(false);
        }
      }
    },
    [onClick]
  );

  return (
    <StyledBasicButton
      variant={"contained"}
      fullWidth
      onClick={clickHandler}
      disabled={disabled}
      round={round}
      uppercase={uppercase}
      isLoading={loading}
      {...props}
    >
      {preserveLoadingWidth && (
        <StyledBasicButtonContent isLoading={loading}>
          {children}
        </StyledBasicButtonContent>
      )}
      {!preserveLoadingWidth && !loading && children}
      {loading && (
        <StyledBasicButtonLoader overlay={preserveLoadingWidth}>
          <Spinner size={SpinnerSize.SMALL} spinnerColor={SpinnerColor.BLACK} />
        </StyledBasicButtonLoader>
      )}
    </StyledBasicButton>
  );
};

export default BasicButton;
